export default __webpack_public_path__ + "static/media/ethereum-white.943bbe1c.png";